export const FEATURE_NAMESPACE = 'feature.rcfa-compliance'
